var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-4"}),_c('h2',[_vm._v("Debugger")]),_c('div',{staticClass:"m-4"}),_c('div',{staticClass:"bordered-block"},[_c('pre',{staticClass:"w-full"},[_vm._v(_vm._s(_vm.data))])])])}
var staticRenderFns = []

export { render, staticRenderFns }